<template>
  <div class="image-admin-page container py-4 px-8">

    <div v-show="pageError" class="error-message alert alert-danger">{{ pageError }}</div>
    <b-alert v-if="pageSuccess" show variant="success" dismissible @dismissed="pageSuccess = null">
      {{ pageSuccess }}
    </b-alert>

    <!-- Botón para mostrar/ocultar formulario de subida -->
    <div class="mb-3 text-start" v-if="!showUploadForm">
      <b-button variant="success" @click="showUploadForm = true">
        <font-awesome-icon icon="upload" /> Subir Nueva Imagen
      </b-button>
    </div>

    <!-- Formulario de Subida -->
    <ImageUploadFormNoAuth
      v-if="showUploadForm"
      @image-uploaded="handleImageUploaded"
      @cancel-upload="handleCancelUpload"
      class="mb-4"
    />
 
    <!-- Lista de Imágenes -->
    <ImageAdminListNoAuth
      v-if="!showUploadForm"
      :refresh-counter="listRefreshCounter"
      @delete-image="handleDeleteImageRequest"
      @load-error="handleListLoadError"
    />

    <!-- Modal de Confirmación de Borrado -->
    <b-modal id="delete-confirm-modal" title="Confirmar Eliminación" v-model="showDeleteConfirm" @ok="confirmDelete" ok-title="Sí, Eliminar" ok-variant="danger" cancel-title="Cancelar">
        <p v-if="imageToDeleteId">¿Estás seguro de que quieres eliminar la imagen con ID {{ imageToDeleteId }}?</p>
    </b-modal>

  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { BAlert, BButton, BSpinner, BModal } from 'bootstrap-vue-next';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ImageAdminListNoAuth from './ImageAdminListNoAuth.vue'; // Usar el nuevo componente
import ImageUploadFormNoAuth from './ImageUploadFormNoAuth.vue'; // Usar el nuevo componente
import { deleteImage } from '../../../services/imageService.js';

const props = defineProps({
  // adminPassword ya no es necesario aquí
});

const showUploadForm = ref(false);
const listRefreshCounter = ref(0);
const pageError = ref(null);
const pageSuccess = ref(null);

const showDeleteConfirm = ref(false);
const imageToDeleteId = ref(null);
const deleteError = ref(null);

function handleCancelUpload() {
    showUploadForm.value = false;
}

function handleImageUploaded() {
    showUploadForm.value = false;
    listRefreshCounter.value++;
    pageSuccess.value = "Imagen subida correctamente.";
    setTimeout(() => pageSuccess.value = null, 8000); // Limpiar mensaje de éxito después de 8 segundos
}

function handleListLoadError(errorMessage) {
    pageError.value = errorMessage;
    // No forzamos re-autenticación aquí, el padre maneja la contraseña
}

function handleDeleteImageRequest(imageId) {
    pageError.value = null; // Limpiar cualquier error de página anterior
    pageSuccess.value = null; // Limpiar cualquier mensaje de éxito anterior
    imageToDeleteId.value = imageId;
    showDeleteConfirm.value = true;
}

async function confirmDelete() {
    if (!imageToDeleteId.value) return;
    try {
        const token = localStorage.getItem('jwt_token');
        if (!token) {
            pageError.value = "No autenticado. Por favor, inicia sesión de nuevo.";
            showDeleteConfirm.value = false;
            return;
        }
        await deleteImage(imageToDeleteId.value, token); // Usar token
        pageSuccess.value = `Imagen ID ${imageToDeleteId.value} eliminada correctamente.`;
        listRefreshCounter.value++;
        showDeleteConfirm.value = false;
        imageToDeleteId.value = null;
    } catch (err) {
        console.error("Error al eliminar imagen:", err);
        const errorMessage = `Error al eliminar imagen: ${err.message}`;
        pageError.value = errorMessage; // Mostrar el error en la alerta de página
        showDeleteConfirm.value = false; // Cerrar el modal para que el error de página sea visible
        setTimeout(() => pageError.value = null, 8000); // Ocultar el mensaje de error después de 8 segundos
    }
}

</script>

<style scoped>
.image-admin-page {
  /* Estilos para la página de administración de imágenes */
}
.error-message {
    color: red !important; /* Asegura que el texto sea rojo */
    font-weight: bold;
    margin-top: 10px; /* Espacio superior para que no esté pegado al título */
}
</style>